import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Discovery } from './discovery';
import { DEFAULT_ZONES, validZones, type BehaviourNotice, type ProximityZones } from './monitoring';

export const useZoneProfiles = create<{
  profiles: Record<string, ProximityZones>;
  save: (id: string, zones: ProximityZones) => void;
}>()(
  persist(
    (set) => ({
      profiles: {},
      save: (id, zones) => {
        if (validZones(zones)) set((s) => ({ profiles: { ...s.profiles, [id]: zones } }));
      },
    }),
    { name: 'entarian.catalogue.proximity-zones.v1' },
  ),
);
export function zonesFor(id: string | null): ProximityZones {
  const saved = id ? useZoneProfiles.getState().profiles[id] : undefined;
  return saved && validZones(saved) ? saved : DEFAULT_ZONES;
}
export const useMonitoring = create<{
  forecast: Discovery | null;
  revision: string;
  status: 'idle' | 'scanning' | 'ready' | 'error';
  message: string;
  notices: BehaviourNotice[];
  rescan: number;
}>(() => ({ forecast: null, revision: '', status: 'idle', message: '', notices: [], rescan: 0 }));
